import React from 'react'
// hooks
import { useModalData } from 'hooks/index'
// components
import { Modal } from 'components/UI'
// view components
import InformationCard from './components/InformationCard'
// constants
import { Modals } from 'constants/modals'
// types
import { IPlanKpi } from 'types/graphql'

interface IIncomingProps {
  entity: IPlanKpi
}

const KPIIntegrationInfoModal: React.FunctionComponent<IIncomingProps> = ({ entity }) => {
  const {
    hideModal,
    modalData: { isOpen }
  } = useModalData({ modalType: Modals.KPI_INTEGRATION_MODAL })

  return (
    <Modal isOpen={isOpen} width={'xs'} hideModal={hideModal}>
      <InformationCard hideModal={hideModal} entity={entity} />
    </Modal>
  )
}

export default KPIIntegrationInfoModal
